export const API_ENDPOINT = process.env.REACT_APP_HOST ?? "";
export const TRACKING_ID = process.env.REACT_APP_TRACKING_ID ?? "";
export const GOOGLE_RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY ?? "";
